import { useState } from 'react'

import { useQuery } from '@apollo/client'

import { GET_SHOPING_LIST_ID } from '../app/graphql/queries'
import { groceryListIdSelector, setGroceryListId } from '../app/groceryList/groceryList.slice'
import { userSelector } from '../app/main/mainSlice'
import { useAppDispatch, useAppSelector } from '../app/store/hooks'

const useFetchGroceryListId = () => {
    const user = useAppSelector(userSelector);
    const dispatch = useAppDispatch();
    const groceryListId = useAppSelector(groceryListIdSelector);
    const [shoppingListId, setShopingListId] = useState<string | null>(groceryListId);

    const { loading: fetchingShopingListId } = useQuery(GET_SHOPING_LIST_ID, {
      skip: !user?.id || groceryListId !== null,
      variables: {
        userId: user?.id
      },
      onCompleted: (data) => {
        if (data?.User_To_Shopping_List?.[0]) {
          const returnedShopingListId = data?.User_To_Shopping_List?.[0]?.shopping_list_id;
          setShopingListId(returnedShopingListId);
          dispatch(setGroceryListId(returnedShopingListId));
        }
      }
    })

    return { loading: fetchingShopingListId, groceryListId: shoppingListId }

}

export default useFetchGroceryListId;
